import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import SectionHeader from '../../../Basic/SectionHeader';
import {
    selectExisitngFortisBCCustomer, selectBupaChecked,
    selectVerifyAccountRetries, selectBupaVerifyRetrieErrorMsg
} from '../../../../selectors/CustomerDetails';

import Radio from '../../../Basic/Radio';
import AccountLogin from '../Common/AccountLogin';

class ExisitngFortisBCCustomer extends React.Component {
    render() {
        const p = this.props;
        const selectedCustomer = p.exisitngFortisBCCustomer;
        const accountLogin = (selectedCustomer == p.lookup.items[1].id || (p.verifyAccountRetries >= 3)) ? null : <AccountLogin />;
        return (
            <div className="form-group">
                <SectionHeader title={p.lookup.title} />
                <div>
                    <Radio name={p.name} title={p.lookup.items[0].name} value={p.lookup.items[0].id}
                        selected={selectedCustomer == p.lookup.items[0].id} onChange={p.onChange} disabled={p.verifyAccountRetries >= 3} />
                </div>
                {accountLogin}
                <div>
                    {p.bupaChecked ? null :
                        <Radio name={p.name} title={p.lookup.items[1].name} info={p.lookup.items[1].desc}
                            value={p.lookup.items[1].id} selected={selectedCustomer == p.lookup.items[1].id} onChange={p.onChange} />}
                </div>
                <div>
                    {p.bupaVerifyRetrieErrorMsg ?
                        <div className="errorMessage" dangerouslySetInnerHTML={{ __html: p.bupaVerifyRetrieErrorMsg }} /> : null}
                </div>
            </div>
        );
    }
}

ExisitngFortisBCCustomer.propTypes = {
    name: PropTypes.string.isRequired,
    exisitngFortisBCCustomer: PropTypes.number,
    onChange: PropTypes.func,
    bupaChecked: PropTypes.object
};

//review cory solution for generic event handling 
export function mapDispatchToProps(dispatch) {
    return {
        onChange: (event) => {
            dispatch({ type: 'radio', name: event.target.name, value: +event.target.value });
        }
    }
}

const mapStateToProps = createStructuredSelector({
    exisitngFortisBCCustomer: selectExisitngFortisBCCustomer(),
    bupaChecked: selectBupaChecked(),
    bupaVerifyRetrieErrorMsg: selectBupaVerifyRetrieErrorMsg(),
    verifyAccountRetries: selectVerifyAccountRetries(),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExisitngFortisBCCustomer);